import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanLoad,
  Route,
} from "@angular/router";
import { AlertService } from "app/core/services/alert.service";
import { AuthService } from "app/core/services/auth.service";
import { PermissionService } from "app/core/services/permissions.service";
import { environment } from "environments/environment";
import { Location } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class UserNoAdminGuard implements CanActivate, CanLoad {
  constructor(
    private router: Router,
    public permissionService: PermissionService,
    public alertService: AlertService,
    private location: Location
  ) {}

  canLoad(
    route: Route,
    segments: import("@angular/router").UrlSegment[]
  ):
    | boolean
    | import("@angular/router").UrlTree
    | import("rxjs").Observable<boolean | import("@angular/router").UrlTree>
    | Promise<boolean | import("@angular/router").UrlTree> {
    return true;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    $("." + "show-collection").removeClass("no-granted");
    let typeUser = AuthService.getFromStorage(
      environment.storageTypeUserNameApi
    );
    let routeChildComponent = state.url.split("/").pop();
    routeChildComponent = routeChildComponent.substr(
      0,
      routeChildComponent.lastIndexOf("?")
    );
    let routeParentcomponent = state.url.split("/")[2];

    if (
      typeUser == "clientuserNoAdmin"
      // &&  this.havePermission(typeUser, routeParentcomponent, routeChildComponent)
    ) {
      // console.log("user noadmin guard");
      return true;
    } else if (typeUser == "adminAccess" || typeUser == "clientuser") {
      return true;
    } else {
      this.router.navigateByUrl("/noadmin-panel");
      // console.log("chao pescao");
      // this.location.back();
      // this.alertService.error("Don't have permission", { autoClose: true });
      return false;
    }
  }

  // Get Permissions User
  havePermission(typeUser, routeParentcomponent, routeChildComponent) {
    const rawPermissionRoutes = AuthService.getFromStorage(
      environment.storageUserPermissionsNameApi
    );
    const permissionRoutes = rawPermissionRoutes
      ? JSON.parse(rawPermissionRoutes)
      : null;

    if (!permissionRoutes || typeof permissionRoutes !== "object") {
      return false;
    }

    const keys = Object.keys(permissionRoutes);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      for (let itemChildrenRoute of permissionRoutes[key]) {
        if (this.matchExact(routeChildComponent, itemChildrenRoute)) {
          $("." + "show-collection").removeClass("no-granted");
          return true;
        } else {
        }
      }
    }
    return false;
  }

  // Match two strings
  matchExact(r, str) {
    var match = str.match(r);
    return match && str === match[0];
  }
}
